/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="12.94"
        height="19"
        viewBox="0 0 12.94 19"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M10.27 0v4.3a6.4 6.4 0 0 1 0 10.4V19H2.66v-4.3a6.41 6.41 0 0 1 0-10.4V0Zm-1 15.33a7.21 7.21 0 0 1-2.14.57h-.16a2.9 2.9 0 0 1-.51 0h-.73l-.3-.05-.38-.07a8.22 8.22 0 0 1-1.36-.42v2.65H9.3ZM6.58 4.08a6.41 6.41 0 0 0-2.39.42 5.43 5.43 0 0 0 1.15 10.29 5.78 5.78 0 0 0 1.1.11 5.44 5.44 0 0 0 2.5-10.28 6.17 6.17 0 0 0-2.35-.54Zm.36 1.54v3.71h3.25v1H5.97V5.62ZM9.26 1H3.65v2.69l.12-.05a6.43 6.43 0 0 1 5.44.08Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'WristwatchIcon';

export default Icon;
